import type { FC, Ref } from "react";
import { BasicCard, type ChildrenProp, type ClassNameProp } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

export type HouseValueTrendProps = ClassNameProp &
  ChildrenProp & {
    title?: string;
    description?: string;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * @deprecated
 */
export const HouseValueTrend: FC<HouseValueTrendProps> = ({
  title = "Ontwikkeling woningwaarde",
  className,
  children,
  ref,
  ...props
}) => (
  <BasicCard
    ref={ref}
    title={title}
    icon="graph2"
    indicatorVariant="infoSurface"
    elevated
    className={mergeClasses(className)}
    {...props}
  >
    {children}
  </BasicCard>
);
